import { Stack, HStack, VStack, Text, Tag } from '@chakra-ui/react';
import Image from 'next/image';

export default function PostListItem({ data }) {
  return (
    <Stack minH="80px">
      <HStack
        w="100%"
        h="100%"
        align="flex-start"
        justify="space-between"
      >
        <VStack
          w="70%"
          align="start"
        >
          <Text
            fontSize="16px"
            lineHeight="24px"
            fontWeight="700"
            color="#333333"
          >
            {data.post_title}
          </Text>
          <Text
            fontSize="12px"
            lineHeight="16px"
            fontWeight="400"
            color="#748598"
          >
            {data.post_date.split(' ')[0]}
          </Text>
          <HStack>
            {data.terms
              .filter((item) => !['UGO', '未分類'].includes(item.name))
              .map((item) => (
                <Tag
                  key={item.term_id}
                  borderRadius="8px"
                  padding="4px 8px"
                  bg="#F5F5F5"
                  color="#748598"
                  fontSize="12px"
                  fontWeight="400"
                >
                  {item.name}
                </Tag>
              ))}
          </HStack>
        </VStack>
        <VStack
          h={['66px', '75px']}
          w="27%"
          my="auto"
        >
          <VStack
            h="100%"
            w="100%"
            position="relative"
            borderRadius="8px"
            overflow="hidden"
          >
            <Image
              src={data.thumbnail}
              alt={data.post_title}
              fill
              style={{ objectFit: 'cover' }}
            />
          </VStack>
        </VStack>
      </HStack>
    </Stack>
  );
}
